import { Switch } from "react-router-dom";
import AuthRoute from "ui/components/AuthRoute";
import CriarEditarClientes from "./Detalhes";
import Listagem from "./Listagem";

function AuditoriaPages() {
  return (
    <Switch>
      <AuthRoute
        path="/relatorios/auditoria"
        exact
        component={Listagem}
      />
      <AuthRoute
        path="/relatorios/auditoria/:id"
        exact
        component={CriarEditarClientes} 
      />
    </Switch>
  );
}

export default AuditoriaPages;
